export default "/images/9a66e7ffc8115da42114a127ca6fef77.avif";